/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 6/5/15.
 */
'use strict';
function ErrorsWarningsModalController (this: JS5Object, _: JS5Object, $timeout: JS5Function) {
    let gridOptions = {
        enableSorting: false,
        enableFiltering: false,
        enableColumnMenus: false,
        showTreeExpandNoChildren: false,
        showHeader: false,
        rowHeight: 26,
        treeRowHeaderBaseWidth: 10,
        columnDefs: [
            {
                name: 'label',
                cellTooltip: true,
                cellTemplate: 'package/editor/components/modals/errorsWarnings/errors-warnings-tree-cell-template.html'
            }
        ],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        }
    };

    let parseValidationResult = () => {
        let allList: JS5Object[] = [];
        let warningList: JS5Object[] = [];
        let errorList: JS5Object[] = [];

        let results = this.resolve.validationResults;
        angular.forEach(results, (result) => {

            let rootNode = {
                label: result.source,
                $$treeLevel: 0,
                type: (result.errors.length) ? 'error' : 'warning'
            };

            allList.push(rootNode);

            if(result.errors.length) {
                errorList.push(rootNode);
            }

            if(result.warnings.length) {
                let warningRootNode = angular.copy(rootNode);
                warningRootNode.type = 'warning';
                warningList.push(warningRootNode);
            }

            angular.forEach(result.warnings, (warning) => {
                let warnNode = {label: warning.description, $$treeLevel: 1, type: 'warning'};
                allList.push(warnNode);
                warningList.push(warnNode);
            });

            angular.forEach(result.errors, (error) => {
                let errorNode = {
                    label: error.description,
                    $$treeLevel: 1,
                    type: 'error'
                };

                if (error.member === 'mvpd') {
                    errorNode.label = _.split(error.description, ':')[0];
                    allList.push(errorNode);
                    errorList.push(errorNode);

                    let mvpdErrors = _.split(_.split(error.description, ':')[1], ',');
                    _.forEach(mvpdErrors, (error: string) => {
                        let mvpdErrorNode = {
                            label: error,
                            $$treeLevel: 2,
                            type: 'error'
                        };

                        allList.push(mvpdErrorNode);
                        errorList.push(mvpdErrorNode);
                    });
                } else {
                    allList.push(errorNode);
                    errorList.push(errorNode);
                }
            });
        });
        this.combinedOptions.data = allList;
        this.errorsOptions.data = errorList;
        this.warningsOptions.data = warningList;
    };

    this.activateTab = (tab: JS5Object) => {
        this.currentTab = tab;
        $timeout(() => {
            this.gridApi.treeBase.expandAllRows();
        }, 50);
    };

    this.onOk = () => {
        if (this.resolve.showCancel) {
            this.close({$value: 'ok'});
        } else {
            this.dismiss({$value: 'cancel'});
        }
    };

    this.onCancel = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.$onInit = () => {
        this.combinedOptions = angular.copy(gridOptions);
        this.warningsOptions = angular.copy(gridOptions);
        this.errorsOptions = angular.copy(gridOptions);

        parseValidationResult();
        this.activateTab('all');
    };
}

angular.module('prism-ui.package').component('errorsWarningsModal', {
    templateUrl: 'package/editor/components/modals/errorsWarnings/errors-warnings-modal-template.html',
    controller: ErrorsWarningsModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
